const carrouselFader = function () {

    const faderImages = function (carrouselSection) {
        const fadeComplete = function () {
            console.log(carrouselSection);
            let arr = carrouselSection.querySelectorAll('.media');
            carrouselSection.appendChild(arr[0]);
        };
        const medias = carrouselSection.querySelectorAll('.media');
        for (let i = 0; i < medias.length; i++) {
            medias[i].addEventListener("animationend", fadeComplete, false);
            medias[i].addEventListener("webkitAnimationEnd", fadeComplete, false);
        }
    }

    if (document.body.classList.contains('page-template-page-path')) {
        const carrousel1 = document.getElementById('carrousel1');
        const carrousel2 = document.getElementById('carrousel2');
        faderImages(carrousel1);
        faderImages(carrousel2);
    }
}

addFunctionOnWindowLoad(carrouselFader);